import { Controller } from "@hotwired/stimulus"

// Sub-abas de idioma (PT | EN | ES) dos formularios da Gestao do site: mostra
// um idioma por vez. Os paineis escondidos continuam DENTRO do <form>, entao
// os tres idiomas sao enviados juntos no salvar.
const LIGADO = ["border-primary-600", "bg-primary-50", "text-primary-700"]
const DESLIGADO = ["border-base-300", "text-base-500"]

export default class extends Controller {
  static targets = ["botao", "painel"]

  trocar(evento) {
    const idioma = evento.currentTarget.dataset.idioma
    this.painelTargets.forEach((painel) => {
      painel.hidden = painel.dataset.idioma !== idioma
    })
    this.botaoTargets.forEach((botao) => {
      const ativo = botao.dataset.idioma === idioma
      LIGADO.forEach((classe) => botao.classList.toggle(classe, ativo))
      DESLIGADO.forEach((classe) => botao.classList.toggle(classe, !ativo))
    })
  }
}
